import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
import { removeAllTagsFromMarkdown } from '../../utils/markdown';
var gtmAccessorySelect = function (_a) {
    var model = _a.model, trim = _a.trim, gtmBodyStyle = _a.gtmBodyStyle, availabilityFlag = _a.availabilityFlag, accessoriesSelected = _a.accessoriesSelected;
    var gtmPayload = {
        event: 'bap_event',
        bap_event: 'accessory_select',
        accessories_selected: accessoriesSelected,
        model: model,
        trim: trim,
        body_style: gtmBodyStyle,
        availability_flag: availabilityFlag,
    };
    var filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export var gtmAccessoryNoOverlay = function (_a) {
    var model = _a.model, trim = _a.trim, gtmBodyStyle = _a.gtmBodyStyle, availabilityFlag = _a.availabilityFlag, accessoriesSelected = _a.accessoriesSelected;
    var gtmPayload = {
        event: 'cannot_be_displayed',
        product_name: accessoriesSelected,
        model: model,
        trim: removeAllTagsFromMarkdown(trim),
        body_style: gtmBodyStyle,
        availability_flag: availabilityFlag,
    };
    var filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export var gtmSelectAccessoryType = function (_a) {
    var accessoryCategory = _a.accessoryCategory, modelName = _a.modelName, trim = _a.trim, bodyStyle = _a.bodyStyle;
    var gtmPayload = {
        event: 'accessory_category',
        accessory_category: accessoryCategory,
        model: modelName,
        trim: trim,
        body_style: bodyStyle,
    };
    gtmEvent(gtmPayload);
};
export default gtmAccessorySelect;
